// extracted by mini-css-extract-plugin
export default {"MatchSelectionPanel":"style_MatchSelectionPanel__+3zis"};